// extracted by mini-css-extract-plugin
export default {"tag":"tag__visitorsTags__aMCrM","popup":"popup__visitorsTags__v3ydQ","hoverTag":"hoverTag__visitorsTags__HvEfr"};